import React, { useContext, useMemo } from "react";
import PropTypes from "prop-types";
import IncentiveCard from "../../../components/IncentiveCard/IncentiveCard";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import sortIncentivesCatalog from "../../../functions/incentives/Sort/sortIncentivesCatalog";
import UserPrefsContext from "../../../context/UserPrefs/UserPrefsContext";
const IncentiveCatalog = ({ incentives, titleText }) => {
  const userPrefs = useContext(UserPrefsContext);

  const sortedIncentives = sortIncentivesCatalog(
    incentives,
    userPrefs.get("incentiveSortType"),
    userPrefs.get("incentiveSortDirection")
  );

  const renderCards = useMemo(() => {
    return sortedIncentives.map((incentive) => (
      <IncentiveCard incentive={incentive} key={incentive.name} />
    ));
  }, [sortedIncentives]);

  if (!incentives) return <LoadingSpinner />;

  return (
    <div className="row mb-3">
      <div className="col-sm-12">
        {titleText && <p className="h3 text-left">{titleText}</p>}
        <div className="d-flex  flex-wrap responsive-justify">
          {renderCards}
        </div>
      </div>
    </div>
  );
};

export default IncentiveCatalog;

IncentiveCatalog.propTypes = {
  incentives: PropTypes.array,
  titleText: PropTypes.element,
  includeTotal: PropTypes.bool,
};
